import React from 'react';
import { useParams } from 'react-router-dom';

import Stepper from '../stepper/stepper';
import Footer from '../footer';
import ConnectAccountBody from './ConnectAccountBody';
import { getGoogleSingInUrl } from './utils';

const ConnectAccount = () => {
    const { accessId } = useParams() as { accessId: string };

    return (
        <>
            <Stepper label="app.request.access.public.step.1.navbar.label" />
            <ConnectAccountBody />
            <Footer
                buttonLabel="app.request.access.public.step.1.submit.button"
                buttonProps={{
                    as: 'a',
                    href: getGoogleSingInUrl(accessId),
                }}
            />
        </>
    );
};

export default ConnectAccount;
